var _defs, _circle, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "house",
    width: 550,
    height: 550,
    viewBox: "0 0 120.35 120.35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebebeb;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6, .cls-7 {\n        stroke: #090607;\n        stroke-width: 1px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #236a92;\n      }\n\n      .cls-4, .cls-5 {\n        fill: #f59100;\n      }\n\n      .cls-6 {\n        fill: #c98015;\n      }\n\n      .cls-7 {\n        fill: #f0f0f0;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60.175,
    cy: 60.175,
    r: 54.705
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1_copy_4",
    "data-name": "Group 1 copy 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1357.21,344.354v-21.12l13.38-15.586L1382.5,322.3l0.32,22.1Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1325.61,322.309h31.63v22.237h-31.45Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1338.6,330.674h8.01v13.877h-7.84Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1346.21,327.374v1.333h-9.85V344.5h-1.68V327.408Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1323.22,322.193h34.49v-1.279h-34.57Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1382.33,322.344h2.97l-14.53-16.838-14.03,15.623v1.4h1.22l12.75-14.461Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1323.64,321.752l13.6-16.013h33.54l-13.89,16.186Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1343.69,304.511h9l6.04,7.686h-8.36Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1349.69,312.3h8.48v-1.249h-8.54Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1338.92,311.732l5.29-5.639,5.04,5.731V310.4l-5.04-6.449-5.5,5.887Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1340.55,317.448h8.23l6.07-5.152h-5.31l-5.26-6.719-5.27,5.955h1.53Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1342.17,311.657h4.68v5.427h-4.65Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1324.83,343.361h58.86v3.573h-58.86v-3.573Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2 copy 2",
    className: "cls-7",
    d: "M1365.85,322.893h9.64v13.55h-9.64v-13.55Z",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1366.12,327.181h9.36",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 1 copy",
    className: "cls-7",
    d: "M1366.12,331.278h9.36",
    transform: "translate(-1293.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 1 copy 2",
    className: "cls-7",
    d: "M1370.81,322.907v13.047",
    transform: "translate(-1293.78 -260.778)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.c8e50ccc.svg";
export { ForwardRef as ReactComponent };